import styled from 'styled-components';
import { getSpacing } from 'stylesheet';

export const Container = styled.div`
  height: ${getSpacing(20)};
`;
